import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import styles from "./asset/accountInfoHolder.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as userActions from "../../reduxStore/actions/userActionsHelper.js";
import { usersData$ } from "../../reduxStore/selectors/userSelectors.js";
import { useOptionalAnnouncements } from "../AnnouncementModal/context/AnnouncementContext";
import * as userApi from '../../api/index';
import { clearAccessToken } from '../../api/config';
import DemoExitModal from '../demoExitModal/DemoExitModal';

const IS_DEMO = process.env.REACT_APP_ENVCONFIG === 'demo';

const AccountInfoHolder = () => {
  const userData = useSelector(usersData$) || {};
  const { username, job, avatar } = userData;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showEndDemoModal, setShowEndDemoModal] = useState(false);
  const [isEndingDemo, setIsEndingDemo] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const location = useLocation();
  const { openAnnouncements, hasUnreadAnnouncements } = useOptionalAnnouncements();

  // Check if current page is user-settings
  const isUserSettingsPage = location.pathname === '/user-setting';

  // Use user's avatar URL or fall back to Prepal logo
  const avatarSrc = avatar || require("../../publicAsset/media/Prepal Logo 3.svg").default;

  const handleLogout = () => {
    if (IS_DEMO) {
      setShowEndDemoModal(true);
      setShowDropdown(false);
      return;
    }

    dispatch(userActions.logoutUser.request());
    setShowDropdown(false);
  };

  const handleConfirmEndDemo = async () => {
    setIsEndingDemo(true);
    try {
      await userApi.logout();
    } catch (err) {
      // Ignore logout failures here — the goal is to exit the demo cleanly on the client.
    } finally {
      clearAccessToken();
      dispatch(userActions.logoutUser.success());
      window.location.assign('https://studyprepal.com');
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div className={styles.userDashboard}>
      <DemoExitModal
        open={showEndDemoModal}
        variant="manualEnd"
        onPrimary={handleConfirmEndDemo}
        onSecondary={() => setShowEndDemoModal(false)}
        isPrimaryLoading={isEndingDemo}
      />
      <div className={styles.frameParent}>
        {!isUserSettingsPage && (
          <div className={styles.usersParent}>
            <div className={styles.users}>
              <div className={styles.colorBg} />
              <img className={styles.philipMartin5aguycwPjwUnspIcon} alt="User Avatar" src={avatarSrc} />
            </div>
            <div className={styles.helloHoaTruongParent}>
              <div className={styles.helloHoaTruong}>Hello, {username || 'User'}</div>
              <div className={styles.student}>{job || 'Undefined'}</div>
            </div>
          </div>
        )}
        <div className={styles.usersParent}>
          <div
            className={styles.bellContainer}
            onClick={openAnnouncements}
            style={{ cursor: 'pointer', position: 'relative' }}
          >
            <img
              className={styles.communicationBellNotificat}
              alt="Notifications"
              src={require("../../publicAsset/media/Bell_Notification.svg").default}
            />
            {hasUnreadAnnouncements && (
              <span className={styles.notificationDot} />
            )}
          </div>
          <div style={{ position: 'relative' }} ref={dropdownRef}>
            <button
              className={styles.communicationBellNotificat}
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              onClick={() => setShowDropdown((prev) => !prev)}
              aria-label="Menu"
            >
              <img alt="Menu" src={require("../../publicAsset/media/Menu_Alt.svg").default} />
            </button>
            {showDropdown && (
              <div className={styles.dropdownMenu}>
                <button
                  className={IS_DEMO ? styles.endDemoButton : styles.logoutButton}
                  onClick={handleLogout}
                >
                  {IS_DEMO ? (
                    <svg className={styles.logoutIcon} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
                    </svg>
                  ) : (
                    <svg className={styles.logoutIcon} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16 17v-3H9v-4h7V7l5 5-5 5M14 2a2 2 0 012 2v2h-2V4H4v16h10v-2h2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h10z" />
                    </svg>
                  )}
                  {IS_DEMO ? 'End Demo' : 'Logout'}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInfoHolder;